/** The stack, said as a stack. Reading order is the customer's own: what they
 *  own on top, what they own underneath, and the one row between that is ours. */
const layers = [
  ['Your WMS', 'Issues work exactly the way it does today.', 'Unchanged'],
  ['Synapse Fleet', 'Translates one instruction into every fleet on the floor.', 'The layer'],
  ['Fleet managers', 'Each vendor keeps its own controller and its own updates.', 'Untouched'],
  ['Vehicles', 'The ones you run now, and the ones you buy later.', 'Any mix'],
] as const;

export function Platform() {
  return (
    <section className="sec" id="stack">
      <div className="sec__label">The orchestration layer</div>
      <div className="visual-head">
        <h2 className="big drift">One layer.<br />Everything stays.</h2>
        <p className="sec__sub reveal">Your systems keep their jobs. Synapse connects them.</p>
      </div>

      <div className="stack">
        {layers.map(([name, what, state], index) => (
          <div className={`stack__layer reveal${index === 1 ? ' stack__layer--us' : ''}`} key={name}>
            <span className="stack__k">{name}</span>
            <span className="stack__v">{what}</span>
            <span className="stack__t">{state}</span>
          </div>
        ))}
      </div>
    </section>
  );
}
